import React, { useState } from 'react';
import { Button, TextButton, Typography } from 'seagull';
import { useIoContext, useStoreActions } from "../../../contexts";
import { StepPage } from "../../components/StepPage";
import { SDALayout } from "../components/SDALayout";
import { Card } from "../components/Card";
import { DeliveryDetails } from "../components/DeliveryDetails";
import { Download } from 'seagull/icons';
import { routes } from "../../../constants";
import { handleRequest } from "../../../infra/utils";
export function DownloadButton(_ref) {
  let {
    file,
    showError,
    relationship,
    service,
    billCommand
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    openNewTab
  } = useIoContext();
  if (!file) return null;
  async function download(fileId) {
    showError(false);
    const result = await handleRequest(api.billCommand.getDeliverableUrl(relationship.id, service.id, billCommand.id, fileId));
    if (!result.success) {
      showError(true);
    } else {
      openNewTab(result.data);
    }
  }
  return /*#__PURE__*/React.createElement(TextButton, {
    skin: "secondary",
    prefixIcon: /*#__PURE__*/React.createElement(Download, null),
    onClick: () => download(file.fileId),
    "data-testid": "sda-download-file-btn"
  }, "Download");
}
export function DownloadFiles(_ref2) {
  let {
    relationship,
    service,
    billCommand
  } = _ref2;
  const [showError, setShowError] = useState(false);
  return /*#__PURE__*/React.createElement(StepPage, {
    header: "Delivery approved",
    showError: showError,
    errorMessage: "An error has occurred. Please try again",
    errorTestid: "sda-download-files-error",
    primaryBtn: /*#__PURE__*/React.createElement(Button, {
      as: "a",
      href: routes.agreement(relationship.id),
      "data-testid": "sda-agreement-link"
    }, "View agreement")
  }, /*#__PURE__*/React.createElement(SDALayout, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, "The service was approved! You may download the files below or from the invoice itself.")), /*#__PURE__*/React.createElement(DeliveryDetails, {
    service: service,
    billCommand: billCommand,
    FileButton: /*#__PURE__*/React.createElement(DownloadButton, {
      showError: setShowError,
      relationship: relationship,
      service: service,
      billCommand: billCommand
    })
  })));
}